var _mask, _mask2, _mask3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentLatitude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    viewBox: "0 0 36 22",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .11h.94v5.358h-.94z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.189.081h.172v.32h-.172z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.04.067h.25v.201h-.25z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 21.5,
    rx: 3,
    stroke: "#c7c7c7",
    strokeWidth: 0.5,
    width: 35.5,
    x: 0.25,
    y: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.947 4.87c.06.072.141.038.212.038 1.36.003 2.72.005 4.08-.002.165 0 .228.036.208.207-.028.247.036.498-.035.743l-.02-.028c-.012-.227.005-.455-.002-.682-.002-.059.026-.125-.034-.173-.258-.019-.516-.008-.774-.008-1.18-.002-2.36 0-3.54 0 1.436.003 2.872-.004 4.308.004.076.074.035.167.037.25.005.193.012.386-.022.578-.059.063-.137.055-.212.055h-4.923c-.067 0-.141.017-.193-.048.027-.181.008-.363.008-.544-.003-1.498-.003-2.996-.002-4.494 0-.296.02-.314.307-.316.175-.001.35.013.525.013.078.083.055.187.055.283.002 1.306 0 2.613.002 3.92 0 .067-.016.138.016.203",
    fill: "#3c6ab2",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.677 3.704c.334.097.507.321.528.683.021.366-.14.648-.45.782-.144.024-.289.042-.433.059-.12.012-.241-.021-.359.018-.092.103-.026.226-.045.338-.015.089.032.185-.032.268-.044-.162-.002-.325-.023-.488.021.163-.025.327.023.489-.173.05-.347.033-.52.007-.019-.677-.003-1.355-.01-2.032 0-.115.046-.15.159-.15.387.007.775-.007 1.162.026m4.883.856.067.002c.035-.012.04-.04.036-.072.15-.286.268-.591.496-.831.154.056.317-.007.472.036.04.114-.104.165-.093.269-.025.082-.056.162-.118.225-.166.305-.336.61-.496.918-.067.127-.015.27-.032.405-.014.114.042.235-.032.343-.045-.197-.01-.397-.023-.595.02.198-.027.398.022.596-.176.033-.352.046-.527-.005.04-.198-.003-.398.01-.504-.006.105.025.304-.012.501-.009-.028-.028-.058-.025-.085.04-.376-.025-.727-.236-1.046-.01-.09-.043-.168-.119-.223l-.396-.72c-.016-.028-.033-.055.005-.08.154-.042.315.02.468-.035.086-.008.085.068.111.117-.003.126.07.213.157.292l.217.39c-.01.045 0 .082.048.102m13.928-2.827c-.29.064-.585.023-.877.023-.17 0-.226.04-.22.218.012.408.003.409.418.409.245 0 .49.005.736-.003.121-.003.149.047.143.157-.005.1.007.182-.14.18-.454-.008-.906-.005-1.36-.002-.082 0-.127-.017-.126-.113.003-.686.001-1.371.002-2.056 0-.027.01-.048.039-.054.04.115.016.235.016.352.004.557.002 1.113.002 1.67-.018.114.029.151.146.15.37-.007.74-.004 1.111-.002.06 0 .125-.023.156.001-.093-.015-.214-.002-.333-.003-.314-.002-.628-.004-.942.002-.107.002-.153-.033-.137-.14v-1.922c.023-.089.094-.086.164-.086.267.002.535.01.802.014.126.001.25-.025.375-.02.19.006.23.084.134.26-.324.005-.648 0-.972.004-.06 0-.124-.018-.182.019-.096.117-.036.25-.038.377.052.246.052.24.328.248.255.007.512-.032.765.023 0 .01-.001.021-.004.032-.075.041-.155.007-.231.017-.256 0-.512.002-.768 0 .24.002.482.002.722.002.094-.012.186.014.28.019l-.001.188c-.34.038-.68.008-.934.018.25.025.59-.026.926.018",
    fill: "#3c69b2",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.124 1.888.07-.154c.11-.086.132-.212.153-.338.065-.158.124-.32.216-.465.047-.02.058-.056.045-.103.015-.117.08-.21.14-.307.042-.02.083.005.127-.005.13-.03.208.028.246.154.02.07.034.145.1.192l-.003-.003c.038.09.055.188.118.267v-.002c.006.047-.01.087-.046.117-.083.085-.137.046-.18-.043-.052-.11-.08-.23-.156-.328-.06.039-.062.126-.13.156-.089.03-.032.102-.046.153-.021.118-.09.219-.124.332-.006.016-.013.031-.021.046-.032.066-.085.124-.063.205.218.011.436-.021.652.015.015.002.024.004.027.002l-.016-.01c-.009-.015-.016-.03-.02-.047-.008-.043-.004-.086.005-.129.028-.068-.005-.136-.005-.203 0-.059.03-.102.07-.141.066-.034.095.028.114.062.08.146.156.3.2.456.028.098.064.177.126.252.085.088.067.233.175.309.077.113.124.24.172.37-.316.035-.316.035-.435-.23-.048-.108-.099-.215-.149-.322-.285-.105-.581-.031-.872-.053-.109-.008-.213 0-.284.101-.061.047-.101.104-.081.187-.007.043-.035.075-.059.109v-.001c-.045.072-.009.187-.118.225l-.293.002c-.052-.075-.001-.13.038-.187l.226-.455c.068-.044.083-.112.08-.186",
    fill: "#3b69b2",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.529.492h.078c.094.04.093.121.093.206-.002.346-.002.692 0 1.038 0 .062-.014.126.015.186-.033.46-.315.758-.754.793-.124-.03-.249-.026-.374-.003-.37-.018-.673-.326-.715-.753.031-.394.006-.787.014-1.18.002-.069-.004-.138.005-.206.17-.085.235-.055.238.122.007.363 0 .727.003 1.09.028.081.014.176.077.247.037.057.077.113.077.185.184.266.578.314.9.111.09-.095.137-.216.196-.33.056-.094.064-.193.06-.304-.015-.345-.003-.69-.008-1.034-.001-.08.032-.13.095-.168",
    fill: "#3c69b2",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.621.494c.07.045.033.114.034.17.003.491 0 .982.002 1.473.001.29-.029.242.255.245.296.003.592.008.887-.003.141-.005.146.063.149.17.002.115-.016.17-.151.168-.44-.009-.881-.008-1.322 0-.13.002-.156-.045-.155-.164.005-.61.003-1.22.003-1.83 0-.248 0-.248.261-.232.041.236.013.475.017.712.005.327.003.654 0 .98 0 .052.026.112-.025.155.056-.048.025-.114.026-.17.003-.497 0-.993.002-1.49 0-.06-.015-.125.017-.184",
    fill: "#3c6ab2",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.024.796c-.004.571-.013 1.143-.01 1.714 0 .143-.015.218-.189.21-.132-.007-.152-.055-.15-.17.005-.522.003-1.043 0-1.564 0-.066.027-.14-.038-.194-.17-.031-.34-.038-.513-.035-.053.001-.117 0-.146-.06-.03-.064-.02-.121.046-.16.509-.022 1.018-.001 1.527-.024.038.002.076.008.11.023.062.028.076.081.06.142-.018.067-.065.078-.13.078-.19-.002-.38-.013-.567.04",
    fill: "#3c69b2",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.504 2.303c.023-.213.173-.315.353-.366.164-.048.32-.008.432.14.036.138.158.25.103.416-.088.27-.249.368-.56.328-.049 0-.086-.051-.14-.032-.108-.054-.162-.148-.185-.263.022-.075.026-.15-.003-.223m.911-1.277-.006.066c-.039.115-.084.223-.227.237l.001-.013c-.03-.01-.056-.022-.09-.013-.276.07-.466-.014-.553-.24-.085-.224.002-.426.242-.56.032-.018.073-.02.096-.056.254-.051.432.06.536.336.022.081.02.162.001.243",
    fill: "#3c6ab2",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.642 2.48c.106.061.201.04.21.134.01.12-.108.049-.146.092-.08.085-.232.081-.257.275-.292-.593-.111-1.173-.155-1.733-.027-.338.088-.391-.38-.382h-.17c-.222-.002-.327-.163-.228-.361.038-.075.125-.082.2-.075.47.045.941.007 1.412.02.074.001.14-.016.16-.099.007-.033-.02-.082.05-.059.04.014.12.026.097.062-.06.099.025.165.033.246.022.21-.084.31-.288.273-.128-.023-.264-.009-.396-.005-.103.004-.1.146-.094.153.115.106.015.217.016.323.002.296 0 .591.001.887 0 .037-.006.096.013.108.14.086.031.112-.078.142",
    fill: "#f3f9f7",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.145 1.243c-.155-.137-.2-.301-.12-.495.038.01.007.133.098.059.004-.004.023.003.033-.004-.004-.002-.008-.003-.011-.006-.138-.125.035-.187.055-.28.127-.076.253-.154.397-.035.03.08.091.055.148.044.054.021.091.06.109.115-.015.073.039.132.045.197.03.32-.224.52-.463.477-.098-.018-.199-.028-.292-.072",
    fill: "#3b6ab2",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.57 5.55c-.055 0-.093.026-.114.076-.024.012-.043.007-.057-.017-.023-.06-.023-.114.033-.157.306-.057.614-.027.92-.02.12.037.146.146.187.243.061.144.374.236.501.15.04-.026.037-.06.026-.098-.018-.067-.054-.127-.081-.19-.054-.14-.094-.286-.18-.412-.01-.016-.019-.032-.026-.049-.121-.285-.238-.573-.345-.864-.068-.163-.117-.335-.226-.478-.15-.046-.304-.018-.456-.019-.059 0-.087.038-.106.087-.042.078-.084.157-.112.241-.015.042-.033.083-.052.123-.061.137-.121.274-.176.414-.04.099-.095.191-.125.294-.076.153-.134.313-.204.468-.039.109-.1.208-.134.32-.033.063-.05.134-.094.193-.016.011-.033.011-.05.001-.056-.093.015-.165.045-.24.191-.468.383-.935.58-1.4.07-.164.173-.314.21-.494.014-.064.076-.125.15-.128.183-.007.365-.007.548-.003.069 0 .08.064.102.118.26.622.524 1.242.786 1.863.035.084.098.13.18.168.086.038.073.038.005.101-.253.235-.525.079-.79.05-.035-.015-.058-.035-.039-.076-.126-.287-.251-.345-.566-.265-.101-.031-.202-.031-.303 0-.012.016-.025.016-.037 0",
    fill: "#f0f5f6",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.874.178c-.14.079-.28 0-.42 0-.374 0-.374-.002-.374.365v.453l.001 3.714c0 .228.01.457.022.685.002.054-.019.066-.06.072-.016-.008-.026-.02-.033-.037-.002-.673-.006-1.347-.006-2.02-.001-1.04.002-2.078-.004-3.117 0-.139.03-.193.176-.181.254.023.51-.03.764.03-.017.019-.045.02-.066.035",
    fill: "#3b66b0",
    mask: "url(#a)",
    transform: "translate(4 8.31)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.01 5.74.033.037c.056.062.13.037.196.037 1.618.001 3.236 0 4.854.002.096 0 .187-.014.278-.039.02.018.017.046.031.067l.01.012c-.043.038-.096.022-.144.022-1.691 0-3.382.001-5.072-.001-.088 0-.226.046-.186-.137",
    fill: "#3566b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.815 2.71c.012.032.048.09 0 .093-.096.005-.2-.004-.288-.038-.076-.03-.123-.113-.11-.202.063-.451.02-.904.023-1.356.002-.215.042-.432-.04-.65-.043-.114.095-.095.167-.106.035-.006.07-.001.11-.001-.021-.09-.191-.017-.138-.173.103.101.267.04.361.16.027.032.09.08.048.104-.157.087-.082.225-.083.337-.009.548-.003 1.096-.006 1.643 0 .064.034.142-.044.19-.025-.028-.037-.06-.041-.096-.02-.605-.001-1.211-.012-1.817-.001-.087.048-.215-.112-.23-.087.032-.076.107-.076.174.002.62-.006 1.239.004 1.857.04.119.177.034.237.11",
    fill: "#f0f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.745 2.379c-.06.25-.308.254-.48.325-.214.09-.453.116-.7.065-.171-.036-.363-.054-.537.021-.161.07-.118-.135-.213-.149-.023-.073.022-.114.073-.152 0-.575 0-1.15.002-1.726 0-.07 0-.138-.038-.2-.027-.127.024-.178.151-.15.236.08.481.048.717.022.165-.018.317.043.478.021.032-.004.048.034.058.064l-.023.024c-.118.046-.235-.017-.353-.003-.27.001-.541-.005-.812.004-.095.02-.087.095-.087.163-.001.598.001 1.195-.002 1.792 0 .121.038.17.162.166.24-.006.479.004.717-.004.286-.008.536-.118.764-.286.03-.019.061-.026.095-.016z",
    fill: "#eef4f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 4.116c-.17-.257-.02-.643.277-.714.062-.014.12-.032.175-.062.11-.06.113-.056.188.048.013.018.043.035.064.035.094-.002.156.077.243.087.013-.012.025-.011.038 0-.035.103-.03.195.011.304.056.151-.024.311-.067.454-.047.159-.529.222-.663.112.018-.023.043-.034.07-.04.217-.006.413-.052.518-.27l.025-.071c.025-.063.026-.125-.003-.187-.054-.153-.125-.288-.31-.31-.138-.039-.266-.023-.382.066-.033.029-.063.06-.087.097-.08.127-.022.274-.062.407-.007.018-.02.033-.036.044",
    fill: "#f2f8fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.677 3.704c-.11.084-.216-.004-.324-.004-.277 0-.553.004-.83-.002-.137-.004-.128.081-.128.173v1.789c-.001.067.02.139-.03.2-.062-.03-.035-.088-.035-.133-.002-.64.001-1.279-.004-1.918 0-.117.022-.166.155-.161.319.012.639.007.958.01.082 0 .163.008.238.046",
    fill: "#355eab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.874.488.066-.038c.004.018.012.036.012.054 0 1.455-.003 2.91-.005 4.364-.063-.063-.034-.143-.034-.214-.002-1.291-.001-2.584-.001-3.875 0-.099.007-.198-.038-.291",
    fill: "#3262ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.256.52c.33.024.528.242.676.5.23.402.173.81-.022 1.213-.037.076-.1.11-.165.146l-.012-.012c-.035-.096.063-.145.08-.222.231-.43.18-.838-.093-1.229-.043-.075-.1-.135-.177-.178-.06-.047-.132-.069-.197-.107-.036-.03-.102-.033-.098-.102z",
    fill: "#eef4f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.131 1.848c-.061-.055-.036-.129-.036-.194-.003-.313-.006-.625 0-.937.004-.147-.051-.196-.19-.153-.022-.024-.022-.048-.001-.073.269-.016.27-.016.269.254-.001.356-.004.711-.006 1.067-.009.015-.02.027-.036.036",
    fill: "#3666b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.582.526c-.516.055-1.033.036-1.55.037-.023-.024-.022-.047 0-.071l1.662-.002c-.015.083-.066.053-.112.035",
    fill: "#3766b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.878.447c-.01.11-.127.104-.186.164-.16.167-.192.335-.07.53.09.145.26.175.47.09.069-.027.061.055.091.085-.036.014-.059.057-.106.046-.08.02-.16.022-.24-.001l-.072-.004c-.274-.1-.327-.293-.257-.64.093-.13.183-.267.37-.27",
    fill: "#3a65af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.145 1.243c.094-.026.185-.003.273.025.155.05.282-.018.363-.128.067-.091.142-.21.054-.344-.03-.045-.028-.108.02-.155.187.309.084.573-.282.72-.072.02-.144.023-.216 0-.091-.002-.173-.021-.212-.118",
    fill: "#3a66b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.614.752c-.004-.221-.054-.262-.272-.218-.228.047-.455.029-.686.01-.17-.015-.343.011-.515.02-.023-.042.012-.054.036-.072.492-.01.983-.018 1.475.004.036.08.014.163.014.246-.014.021-.03.024-.052.01",
    fill: "#3766b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.177.492-.036.072v1.964c-.013.017-.025.018-.037 0l-.001-2.036z",
    fill: "#3763ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.274 2.236c.049-.133.139-.174.283-.166.26.014.522.003.784.005.057 0 .13-.022.145.07-.273-.045-.549-.024-.823-.035-.186-.007-.316.048-.357.243-.014.067-.057.109-.116.137l.03-.116c-.02-.06.01-.102.054-.138",
    fill: "#eaf3f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.529.492c-.064.096-.084.2-.076.316.021.324-.028.65.027.975.01.065.015.181-.098.216.06-.46.02-.922.03-1.382.002-.084 0-.156.117-.125",
    fill: "#3563ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.621.494v1.838h-.037v-1.841c.013 0 .025.002.037.003",
    fill: "#3761ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.288 1.243.048-.12c.147.265.283.535.372.826.014.03.022.06-.005.088-.048-.021-.046-.11-.127-.09-.044.01-.05-.015-.045-.055.038-.26-.083-.462-.243-.649",
    fill: "#3a68b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.582.526c.04-.002.084.007.112-.035.15.044.055.162.067.244.012.084-.072.064-.123.064l-.614-.003c-.037-.063-.05-.093.05-.064.182.054.366-.058.552-.004.031.01.053-.023.064-.055.033-.1-.07-.1-.108-.147",
    fill: "#3a65af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.842 2.792c.178.04.336-.014.447-.147.12-.144.107-.313.008-.472-.02-.033-.046-.06-.008-.096.055.063.12.121.124.214.023.071.02.143 0 .215-.115.315-.243.396-.571.358-.02-.024-.023-.048 0-.072",
    fill: "#3966b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.162.446c.186-.018.242.137.296.255.089.196.088.487-.183.62-.016.012-.032.01-.047-.002-.013-.073.044-.111.08-.16.092-.13.135-.265.049-.415-.015-.055-.05-.095-.094-.129-.035-.051-.093-.085-.113-.148z",
    fill: "#e6f0f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.7 5.856c.008-.002.016-.003.025-.003.067-.015.136-.018.204-.013.18.013.352.01.431-.198.006-.016.031-.018.05-.019l.046.003c-.121.357-.122.363-.501.332-.087-.006-.218.048-.256-.102",
    fill: "#f4f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.498 1.439-.849-.006c-.265-.001-.265 0-.244-.265.05.077.082.178.213.129-.022.091-.111.031-.143.098.284 0 .559-.002.834 0 .064.002.14-.029.19.044",
    fill: "#fafbf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.032.492v.071c-.099.16.025.162.123.162.165 0 .326.01.482.067-.2.003-.4.002-.6.01-.093.003-.133-.036-.114-.12.016-.073-.074-.213.109-.19",
    fill: "#3865af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.186 2.328c-.218.262-.788.192-.9-.11.235.216.5.248.792.134.034-.013.072-.016.108-.024",
    fill: "#3665af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.715 1.922c-.06-.064-.032-.143-.033-.215-.003-.324-.004-.65 0-.974.002-.092-.016-.172-.075-.241.089-.023.123.01.121.103-.007.442-.01.885-.013 1.327",
    fill: "#3261ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.508.717c-.061.272.008.492.257.64-.03.004-.064.002-.092.013-.052.02-.141.124-.085-.048.004-.01-.016-.04-.03-.044-.12-.036-.163-.089-.1-.222.048-.1-.04-.235.05-.339",
    fill: "#f6f9ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.904.491.001.073-.001 1.198c0 .066.023.138-.032.197-.034-.467-.006-.934-.014-1.401 0-.032.004-.063.046-.067",
    fill: "#335daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.236 1.319.039.002c-.065.11-.348.168-.49.084-.076-.046-.2-.059-.2-.192l.023-.017c.07.002.11.06.169.083.108.06.22.077.338.028.039-.016.084-.026.12.012",
    fill: "#e8f1f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.201.517c.056.032.021.06-.005.085-.076.071-.116.138.014.193.035.015.047.041.03.074-.004.008-.038.014-.044.008-.115-.125-.103.04-.17.104v-.234c.022-.104.065-.192.175-.23",
    fill: "#3f68b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.614.752.035.002c.012.007.016.013.013.02-.004.009-.007.012-.01.012-.403.024-.806.016-1.209.005.049-.06.116-.037.176-.038.331-.002.663 0 .995 0",
    fill: "#3460ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.488 1.733h-1.034v-.036h1.042z",
    fill: "#355eab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.182 1.329c.097-.059.163-.147.227-.237-.005.072.142.122.031.206-.078.06-.159.134-.258.03",
    fill: "#f7f9ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.735 4.448c.002.048-.182.23-.227.228-.036-.002-.068-.028-.053-.057.05-.097.136-.163.224-.223.02-.015.05.023.056.052",
    fill: "#fafcf6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.617 1.432c-.088.044-.16.072-.221-.017-.034-.048-.104-.1-.046-.16.073-.077.098.03.14.06.044.029.078.071.127.117",
    fill: "#fcfcf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.554.6c.182-.225.396-.28.608-.154l-.006.007c-.045.047-.104.043-.162.047-.06.002-.122-.009-.18.017-.08.03-.14.093-.213.134-.017.005-.034.003-.051-.004-.011-.017-.01-.032.004-.047",
    fill: "#e6f0f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.476 5.815.038.076c-.106.05-.218-.006-.34-.195z",
    fill: "#f4f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.554.6.005.048c-.01.187.004.373.033.558l-.006.007c-.116-.057-.186-.298-.126-.455.021-.056.061-.105.093-.158",
    fill: "#e8f1f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.22.862c-.02-.013-.056-.022-.06-.038-.045-.227-.195-.31-.412-.303.247-.09.334-.055.42.168.021.056.035.115.053.173",
    fill: "#3866b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.485 3.51h-.038l-.042-.06c-.036-.046-.11-.09-.037-.151.04-.034.105-.02.13.028.03.058.136.134-.013.183",
    fill: "#fcfcf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.527 1.313c-.016.02-.019.028-.023.029-.084.019-.17.041-.241-.031-.008-.008-.004-.044.003-.047.093-.037.18-.03.261.05",
    fill: "#fafbf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.063.133c.07.024.058.092.077.14.016.039-.013.057-.048.06-.068.005-.085-.037-.083-.095 0-.045.004-.087.054-.105",
    fill: "#fdfcf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.703 2.037.005-.088c.115.1.128.252.19.379-.043.05-.06.01-.075-.023-.041-.089-.08-.179-.12-.268",
    fill: "#3965af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 4.116.002-.039c.029-.015.05.001.07.018.067.118.214.158.276.282l-.082.003c-.172-.004-.198-.155-.267-.264",
    fill: "#e4eff7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.347 1.396c.007.139.033.286-.153.338.026-.124.096-.228.153-.338",
    fill: "#3e67b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.295 4.068c-.124-.06-.215-.136-.157-.292z",
    fill: "#4167b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.003.412c-.09.011-.14.062-.15.151-.138-.054-.03-.124.004-.16.03-.03.108-.13.146.01",
    fill: "#f6f9f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.34 5.21c.134-.048.272-.07.414-.04-.042.03-.088.05-.143.043-.06.037-.135-.007-.195.032h-.04c-.015-.008-.027-.02-.036-.035",
    fill: "#3765af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.286.945c.031.001.063.005.07.044.006.039-.019.058-.052.061-.04.005-.08-.003-.08-.052-.002-.035.024-.054.062-.053",
    fill: "#fafbf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.63 3.695c-.156-.014-.32.05-.47-.036.157.008.32-.057.47.036",
    fill: "#335eab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.746.526c-.027.054-.066.09-.13.063-.06-.025-.033-.068-.018-.107.052.007.112-.015.148.044",
    fill: "#4168b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.027 3.66c-.15.084-.312.022-.468.035.15-.093.312-.028.468-.036",
    fill: "#3460ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.072 2.714.119-.225c.006.099.054.22-.119.225",
    fill: "#eaf3f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.34 5.21.037.036h-.414c.12-.073.252-.02.377-.036",
    fill: "#3561ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.131 1.848.036-.036.042.22c-.152-.008-.045-.126-.078-.184",
    fill: "#3f63ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.587 2.712c.125-.052.25-.056.374.003-.125.02-.25.02-.374-.003",
    fill: "#325fab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.336 1.125c-.087-.068-.128-.156-.118-.266.078.071.112.163.118.266",
    fill: "#3966b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.95 4.494c.114.035.146.114.12.223z",
    fill: "#3662ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.79 4.047c-.031-.012-.059-.03-.056-.066s.027-.055.064-.045c.038.01.04.043.04.075 0 .033-.019.043-.048.036",
    fill: "#f9faee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.42 4.189c.023-.084.061-.16.118-.225.045.119-.031.175-.118.225",
    fill: "#e2edf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.24 1.774c.047.07.04.119-.002.196-.045-.083-.049-.131.001-.196",
    fill: "#fafbf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.478 2.924c-.002.049-.037.057-.075.054-.014 0-.039-.016-.038-.023.003-.04.034-.062.069-.071.026-.007.044.01.044.04",
    fill: "#f4f9f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.274 1.47h.22c0 .013.002.026.003.038-.032.009-.04.142-.102.017-.01-.02-.079-.012-.12-.017-.013-.008-.017-.016-.013-.025.004-.008.008-.012.012-.012",
    fill: "#3865af"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.271.401c0-.011-.001-.023-.004-.035l.006-.285c.114.107.121.214-.003.319",
    fill: "#3c69b2",
    mask: "url(#b)",
    transform: "translate(32.528 8.423)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.466 2.98c-.022-.004-.06.002-.046-.035.009-.023.043-.04.069-.053.004-.003.032.022.035.036.009.044-.024.05-.058.052",
    fill: "#f3f8f3",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.887 2.489-.072.152c-.073-.097-.046-.146.072-.152",
    fill: "#f1f8f5",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.607 5.55c.101-.058.202-.058.303 0z",
    fill: "#f4f9f8",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.124 1.888c.054.097.012.153-.081.186l.08-.186",
    fill: "#4068b1",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.166.067c.053.005.119.003.118.077 0 .073-.064.075-.119.075-.054.001-.119-.002-.118-.075 0-.072.065-.074.119-.077",
    fill: "#f4f9f2",
    mask: "url(#c)",
    transform: "translate(26.189 8.083)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.57 5.55h.037c.012.04.054.072.025.117-.003.005-.032 0-.044-.007-.046-.028-.041-.068-.018-.11",
    fill: "#f4f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.56 4.56c-.016.026-.037.03-.056.006-.031-.037-.033-.076.008-.109.025.03.052.06.048.103",
    fill: "#3863ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.415 1.026v-.243c.05.08.047.162 0 .243",
    fill: "#617ebd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.842 2.792v.072c-.058-.008-.107-.036-.15-.074.052-.065.1.017.15.002",
    fill: "#365fac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.817 2.529c.001.065-.068.116-.038.187-.08-.081-.045-.139.038-.187",
    fill: "#dbeaf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.504 2.303c.056.073.053.148.003.223-.02-.074-.026-.149-.003-.223",
    fill: "#315fab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.836 1.361.241.001c-.08.048-.16.048-.24-.001",
    fill: "#617ebd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.663 4.49c.034.017.044.043.021.074-.018.025-.039.027-.057-.002.002-.03.008-.056.036-.072",
    fill: "#3f69b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.225 2.956c-.023.002-.044.01-.05.003-.01-.01-.017-.031-.014-.046.004-.02.025-.022.038-.009.01.011.015.03.026.052",
    fill: "#f5f9ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.04.528c-.017.007-.033.02-.048.02-.021 0-.03-.023-.017-.038.01-.011.033-.013.05-.015.003 0 .008.019.014.033",
    fill: "#fcfcef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.608.828c.046.061.046.102-.045.103z",
    fill: "#3762ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.416 5.245c.057-.058.129-.028.195-.031-.06.041-.127.04-.195.031",
    fill: "#3c69b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.414 2.506v-.216c.042.071.042.143 0 .215",
    fill: "#3c6ab2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.357 1.36.216.002c-.072.043-.144.039-.216-.001",
    fill: "#3b6ab2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.371 4.984h-4.389c.056-.06.111-.036.158-.036 1.345-.002 2.69-.002 4.035 0 .066 0 .14-.025.196.036z",
    fill: "#3460ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.402 5.844c-.03-.013-.03-.04-.03-.067v-.793c.08.284.021.573.03.86",
    fill: "#3761ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.609 4.264c.102.357-.024.526-.396.527-.296.001-.296.001-.296-.297 0-.385 0-.386.384-.378.05 0 .1.002.15.004.089.008.147.051.158.144",
    fill: "#eff6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.875 4.162v.594h-.018v-.596l.018.001",
    fill: "#345fab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.886 5.853c-.1-.054-.026-.14-.034-.21-.014-.115-.004-.233.035-.35v.56z",
    fill: "#355eab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.609 4.264-.159-.144c.113-.025.163.02.158.144",
    fill: "#4266b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.33 5.848v-.673c.007.225.088.453.002.676z",
    fill: "#345eab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.86 5.856c-.09-.21-.01-.427-.047-.639l.047-.001v.639z",
    fill: "#3561ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.104 2.528h.036c-.009.132.086.113.166.113.433 0 .866 0 1.3.037h-.713c-.214 0-.428-.005-.642.002-.116.004-.164-.037-.147-.152",
    fill: "#3460ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.454 2.426h1.156v.018h-1.16l.005-.018",
    fill: "#365fac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.274 1.47v.038h-.823v-.038z",
    fill: "#3762ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.357.833v.557h-.017v-.55l.017-.008",
    fill: "#355fab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.355 1.813v.515h-.013v-.514h.013",
    fill: "#345fab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.605 1.54c-.001-.012.002-.022.008-.031.097-.11.129-.25.173-.383.023-.066.049-.144.114-.157.089-.017.094.082.127.137.028.048.05.1.088.142.037.051.07.104.09.164.006.06.05.11.045.171l-.004.15c-.2.044-.405.06-.604.03-.16-.026-.034-.146-.037-.224",
    fill: "#f9fafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.092 1.282c-.1-.069-.109-.192-.18-.3-.095.125-.14.265-.186.4-.023.066-.035.12-.113.126l.137-.343c-.021-.06.01-.101.052-.139.071-.045.029-.171.135-.192.075.14.202.264.155.448",
    fill: "#e8f2f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.092 1.282c-.012-.163-.133-.289-.155-.448l.115-.092c-.066.196.071.309.101.455.017.084.082.052.135.046l-.038.152c-.02.019-.03.057-.072.037z",
    fill: "#3e67b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.605 1.54c-.037.159.023.21.187.195.15-.014.302-.057.454-.002.004.012.003.024-.004.035-.234.036-.468.039-.702-.001-.06-.099.032-.155.065-.228",
    fill: "#d9e6f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.54 1.767.702.001c.016.01.054.036.034.036-.247.004-.495-.002-.742-.006-.001 0-.004-.01-.003-.015 0-.006.006-.011.009-.016",
    fill: "#345daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.178 1.432.072-.037c-.01.063.082.125 0 .188-.027-.049-.09-.08-.072-.151",
    fill: "#3d64af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.802 1.026-.052.14c-.041-.07-.042-.122.052-.14",
    fill: "#3361ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.274 2.236-.054.138c-.04-.068-.042-.122.054-.138",
    fill: "#3162ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.709 2.428h1.173v.024h-1.179l.005-.024",
    fill: "#365fac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.707.79-.067.003c-.054.052-.027.118-.027.178-.003.5-.001 1.002-.002 1.503 0 .214-.022.229-.245.177-.04-.212-.01-.425-.017-.638-.013-.395.02-.79-.019-1.184-.008-.007-.01-.014-.005-.024-.189-.08-.386-.016-.578-.033-.075-.006-.152.007-.172-.094v-.04c.024-.034.015-.089.066-.106.426-.014.853-.003 1.28-.005.068 0 .12.031.162.081.022.028.028.06.019.093-.02.045-.063.052-.102.067-.097.017-.198-.022-.293.022",
    fill: "#3c69b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.009.752c.016-.03.044-.037.075-.037.036-.045.103-.046.14-.105-.06-.046-.097.009-.14.029-.1-.077-.215-.078-.333-.077-.38.003-.76.002-1.14.002-.024-.042.012-.054.036-.072h1.628c.137.033.097.144.086.225-.011.087-.098.05-.154.052-.066 0-.135.019-.198-.017",
    fill: "#3866b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.367 2.64c.182.034.235-.042.23-.224-.012-.478-.005-.956-.003-1.434 0-.064-.03-.141.046-.189 0 .593 0 1.187-.003 1.78 0 .05.025.138-.057.13-.082-.006-.2.087-.248-.061.011-.019.023-.02.035-.001",
    fill: "#3561ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.367 2.64-.035.002-.002-1.813c.06.056.035.13.035.195.002.539.002 1.078.002 1.617",
    fill: "#3265b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.009.752c.055 0 .111.004.166 0 .057-.006.133.03.163-.048.032-.081.013-.157-.063-.211.18-.036.109.1.121.178.016.094-.02.134-.123.129-.188-.01-.377-.008-.566-.01.093-.076.202-.02.302-.038",
    fill: "#345fab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.575.678c.058.09.149.066.233.076.172.022.355-.063.517.051-.21-.002-.42-.007-.63-.006-.09.001-.15-.011-.12-.12m.072-.187-.036.072c-.001.03-.007.058-.036.074.01-.055-.065-.153.072-.146",
    fill: "#3360ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.41 5.623c-.138.28-.27.324-.685.23.016-.072.03-.145.08-.204.09-.076.105-.19.148-.291.078-.147.125-.308.205-.455.035-.112.12-.208.11-.334.047-.148.104-.291.184-.424.04-.024.058-.058.043-.105.02-.086.053-.167.105-.239.06-.1.144-.133.26-.123.131.012.264 0 .396.01.09.16.155.331.216.504.07.32.198.616.357.9l-.004-.004c.074.132.058.305.19.41.2.38.2.371-.214.384-.175.006-.286-.033-.324-.216-.014-.066-.052-.126-.08-.189-.133-.064-.282-.036-.415-.03-.186.01-.378-.034-.56.041z",
    fill: "#3b69b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.829 5.092c-.166-.133-.2-.34-.266-.52-.043-.117-.156-.233-.091-.38z",
    fill: "#3865af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.422 5.488c.009-.034.033-.06.065-.06.302-.004.604-.005.905-.005.009 0 .023.015.024.025.001.009-.012.02-.018.029z",
    fill: "#3464af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.256 3.687c-.075.053-.156.01-.233.009-.153-.002-.3-.002-.423.105.01-.114.067-.165.185-.15.156.022.319-.041.47.036",
    fill: "#3460ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.192 4.908c-.095.142-.11.323-.227.454-.015-.009-.027-.022-.035-.038l.216-.467c.025.008.029.035.046.051",
    fill: "#3e66b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.015 5.498c-.09.02-.125-.057-.13-.11-.01-.103-.088-.191-.06-.3.104.118.14.267.19.41",
    fill: "#3b65af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.93 5.324.035.038c-.037.213-.06.255-.16.287z",
    fill: "#4067b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.192 4.908-.046-.051c.012-.109.074-.195.122-.288.085.138-.063.223-.076.34",
    fill: "#3c64af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.495 4.04c.052.062.04.098-.043.105z",
    fill: "#3761ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.632.492c.139-.034.198-.002.195.163-.012.662-.008 1.324-.01 1.986-.1.028-.206.102-.277-.045v-1.912c0-.077-.025-.169.092-.192",
    fill: "#3b68b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.632.492c-.084.052-.074.135-.074.217l.001 1.931c.011.034.001.048-.035.039-.034-.476-.007-.951-.014-1.427-.004-.213.002-.426-.003-.64-.002-.093.017-.147.125-.12",
    fill: "#345daa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.524 2.679.035-.039c.086.022.172-.036.258.001l-.002.069c-.096-.016-.2.035-.291-.031",
    fill: "#355caa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.85 2.187-.117.18-.06.012c-.3.218-.63.327-1.005.302-.156-.01-.314 0-.471-.003-.195-.002-.246-.048-.248-.244-.005-.307-.002-.615-.002-.923 0-.263.003-.527 0-.79-.002-.101.02-.175.132-.19.277-.009.555-.002.83-.039.117-.025.225.036.34.037l.123.068c.034.087.115.089.188.102.077.037.146.083.178.167-.022.046-.045.085 0 .137.255.301.295.682.115 1.04-.024.048-.035.095-.004.144",
    fill: "#3c69b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.08.563c-.083.02-.117.066-.116.156.004.565.001 1.129.002 1.693 0 .159.069.243.243.23.317-.022.637.034.954-.035.187-.04.329-.177.51-.228-.221.239-.507.321-.818.33-.264.01-.528-.001-.792.005-.105.002-.142-.028-.142-.137.005-.654.003-1.308.002-1.961 0-.087.004-.155.119-.124.024.018.061.029.037.071",
    fill: "#3766b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.08.563-.038-.07h.867c-.271.082-.551.07-.83.07",
    fill: "#3766b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.848 4.377c-.123-.064-.25-.122-.304-.264-.018-.165-.004-.328.035-.489.01-.04.038-.064.07-.083.144-.03.277-.14.434-.05.228.072.344.247.308.476-.006.04-.006.072.008.107-.105.244-.302.322-.551.303",
    fill: "#3c6ab2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.4 4.074c-.04-.025-.058-.053-.052-.108.028-.245-.042-.355-.279-.456-.011-.01-.015-.02-.01-.029.004-.01.008-.014.012-.014.219.003.3.149.343.332.019.07.024.14-.002.21l-.013.065",
    fill: "#3763ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.579 3.624c.03.166-.002.328-.035.49l-.042-.037c-.008-.157-.049-.319.077-.453",
    fill: "#3c67b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.07 3.467v.043c-.113-.065-.214-.006-.313.035-.041.016-.073.053-.107-.004.127-.1.26-.169.42-.074",
    fill: "#3d64af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.412 4.009.002-.21c.043.07.04.14-.002.21",
    fill: "#3c6ab2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.85 2.187c-.069-.075-.127-.15.017-.207-.04-.101.067-.17.062-.26-.01-.16.02-.336-.126-.462-.026-.022-.007-.045.008-.063.07-.084.004-.091-.055-.126-.086-.05-.192-.12-.018-.203.329.416.356.857.111 1.32",
    fill: "#3b69b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.56.7c-.12.02-.165-.005-.188-.103.055.049.146.031.188.103",
    fill: "#3964af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.59.637c.03-.093.118-.113.19-.154.074.033.141-.03.214-.013.118-.005.207.055.291.128.082-.003.1.05.102.117-.013.015-.025.036-.017.05.124.226-.025.367-.165.497-.154.143-.324.08-.487 0-.225-.17-.217-.39-.128-.625",
    fill: "#3c6ab2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.744 1.243c.324.106.436.072.621-.199.037-.053.028-.113-.01-.175-.029-.049-.091-.127.032-.154.119.222.083.365-.151.604-.164.064-.329.11-.493 0-.02-.025-.023-.05 0-.076",
    fill: "#3f69b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.285.598c-.11-.024-.194-.12-.315-.11-.012-.008-.016-.014-.012-.021s.008-.01.012-.01l.186-.004c.043.049.134.054.13.145",
    fill: "#3a64ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.744 1.243v.076l-.152-.113c-.118-.18-.118-.366-.033-.558l.031-.01c.008.041.036.097.019.124-.14.215.005.345.135.481",
    fill: "#3864af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.97.457v.03c-.062-.05-.131.17-.19-.004.057-.054.123-.047.19-.026",
    fill: "#3b66b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.961 4.45c.007-.149-.048-.308.187-.3.291.01.448.104.454.309.002.06.011.117-.09.128-.065.007-.118.092-.182.133-.091.058-.206.064-.29.02-.123-.061-.063-.201-.079-.29",
    fill: "#f6f9fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.084.639c-.003-.073.017-.126.104-.108.039.008.097.013.094.07-.004.058-.04.103-.105.11-.03.004-.062.003-.093.004z",
    fill: "#3a6ab3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.873 4.382.067-.104.158.367c.034.03.055.064.042.111.081.272.081.277-.215.27-.095-.002-.2.042-.285-.042-.003-.127.046-.234.125-.33.04-.047.06-.102.066-.163-.013-.047.007-.08.042-.109",
    fill: "#edf2f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.764 4.654c-.02.118-.073.224-.124.33-.027.006-.08.021-.076.017.08-.109.028-.294.2-.347",
    fill: "#3b66b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.157 5.09h-.467v-.018h.483z",
    fill: "#3560ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.873 4.382-.042.11c-.064-.062-.021-.11.02-.157z",
    fill: "#3864ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.14 4.756-.042-.111.023-.046c.039.048.083.096.019.157",
    fill: "#3d64af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.402.974.183.204c.096.065.103.17.119.27 0 .102.001.205-.002.308-.013.06-.025.12-.075.165-.172.337-.461.465-.824.46-.188-.001-.376-.005-.563-.008-.037-.028-.028-.068-.028-.104v-1.373c0-.036-.009-.076.026-.104l-.006.007c.339-.04.676-.077 1.006.057.067.027.12.063.164.118",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.402.974c-.364-.229-.772-.168-1.17-.174.014-.013.026-.036.04-.037.344-.017.689-.054 1.027.05.079.023.087.096.103.162",
    fill: "#3865af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.238.792.002 1.58c-.051-.022-.047-.068-.047-.112v-1.354c0-.044-.002-.09.045-.114",
    fill: "#345fac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.627 1.92.044-.149c.025-.112.022-.225.001-.338l-.087-.255c.055-.06.085.004.095.032.087.245.114.493-.009.733-.032.064-.034-.002-.044-.022",
    fill: "#3666b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.973 2.253c.035-.107.112-.11.195-.095.012.003.029.036.025.04-.059.07-.134.074-.22.055",
    fill: "#fcfcf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.672 1.434c.05.112.052.225 0 .337z",
    fill: "#3c69b2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLatitude);
export default __webpack_public_path__ + "static/media/payment-latitude.a5fa50e95a1667349c31547191e42aa6.svg";
export { ForwardRef as ReactComponent };